export default "__VITE_PUBLIC_ASSET__ebf67156__"